import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_LAST_POST_SLUG = 'lastPostSlug/SET';

export const setLastPostSlug = createAction(SET_LAST_POST_SLUG);
